import styled from "styled-components";
import React from "react";

export const Container = styled.div<{ alert: boolean; hasSrc: boolean }>`
  position: relative;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  margin-top: 16px;
  margin-bottom: -18px;
  justify-content: center;
  display: flex;
  align-items: center;
  // background-color: #f0f0f0; // 빈 박스 배경색
  width: 100%;
  height: ${({ hasSrc }) => (hasSrc ? `100%` : `180px`)};
  border: ${({ alert }) => (alert ? `1px solid red` : `none`)};

  @media (max-width: 768px) {
    height: 140px;
  }
`;

export const TitleHighlight = styled.div<{ image: string }>`
  background-image: url(${({ image }) => image});
  background-size: cover;
  background-repeat: no-repeat; /* 이미지 반복 방지 */
  background-position: center; /* Centers the image */
  position: relative;
  width: 100%;
  height: 140px;
  margin: -20px -20px -60px -20px;
  @media (max-width: 768px) {
    height: 140px;
  }
  z-index: 21;
  border-radius: 8px 8px 0 0; /* 위쪽 두 모서리만 라운드 */
`;

export const PlusIcon = styled.img`
  width: 70px;
  height: 40px;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`;

export const HiddenInput = styled.input`
  display: none;
  cursor: pointer;
  z-index: 1;
  &:hover {
    opacity: 0.5;
  }
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(255, 255, 255, 0.7);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
`;

export const ImageCheck = styled.div<{ backgroundImage: string }>`
  position: absolute;
  top: 10px;
  right: 10px;
  background-image: url(${({ backgroundImage }) => backgroundImage});
  background-size: 100% auto; /* 이미지 크기 조정 */
  background-repeat: no-repeat; /* 이미지 반복 방지 */
  width: 30px;
  height: 30px;
  cursor: pointer;
`;

export const ImageDelete = styled.div<{ backgroundImage: string }>`
  position: absolute;
  top: 50px;
  right: 10px;
  background-image: url(${({ backgroundImage }) => backgroundImage});
  background-size: 100% auto; /* 이미지 크기 조정 */
  background-repeat: no-repeat; /* 이미지 반복 방지 */
  width: 30px;
  height: 30px;
  cursor: pointer;

  &::after {
    content: "이미지 삭제"; /* 툴팁 내용 */
    position: absolute;
    bottom: -100%; /* 요소의 위쪽에 툴팁 표시 */
    left: 30%;
    transform: translateX(-50%);
    background-color: gray; /* 툴팁 배경 색상 */
    color: #fff; /* 툴팁 텍스트 색상 */
    padding: 3px 5px;
    border-radius: 5px;
    white-space: nowrap;
    opacity: 0;
    font-size: 12px;
    pointer-events: none;
    transition: opacity 0.3s;
    z-index: 100; /* 다른 요소 위에 표시되도록 z-index 설정 */
  }

  &:hover::after {
    opacity: 1; /* 마우스를 올렸을 때 툴팁 표시 */
  }
`;

export const Label = styled.label`
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;

  &::after {
    content: "신청서 메인 배너이미지 추가                 프로그램 브랜드 이미지가 전달되는 대표 이미지를 추가해주세요.";
    width: 200px;
    position: absolute;
    top: 60%;
    left: 60%;
    transform: translateX(-50%);
    background-color: gray; /* 툴팁 배경 색상 */
    color: #fff; /* 툴팁 텍스트 색상 */
    padding: 3px 5px;
    border-radius: 5px;
    white-space: pre-wrap; /* 줄 바꿈을 허용 */
    opacity: 0;
    font-size: 12px;
    pointer-events: none;
    transition: opacity 0.3s;
    z-index: 100; /* 다른 요소 위에 표시되도록 z-index 설정 */
  }

  &:hover::after {
    opacity: 1; /* 마우스를 올렸을 때 툴팁 표시 */
  }
`;

export const ZoomButton = styled.button`
  display: block;
  width: 30px; /* 원하는 너비로 설정 */
  height: 30px; /* 원하는 높이로 설정 */
  margin-bottom: 3px;
  border: 1px solid #000; /* 테두리 */
  background-color: transparent; /* 배경색 */
  border-radius: 5px; /* 모서리 둥글게 */
  font-size: 20px; /* 폰트 크기 */
  cursor: pointer; /* 마우스 포인터 */
`;

export const ZoomButtonContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
  top: 90px;
  right: 10px;
`;

export const MoveButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 90px;
  right: 0px;
`;

export const MoveButton = styled.button<{ top: number; right: number }>`
  position: absolute;
  width: 20px;
  height: 20px;
  top: ${({ top }) => top}px;
  right: ${({ right }) => right}px;
  background-color: transparent;
  border-radius: 5px;
  font-weight: bold;
  font-size: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
